import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import {
  type EnvironmentProviders,
  inject,
  isDevMode,
  LOCALE_ID,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import {
  provideTransloco,
  provideTranslocoInterceptor,
  TranslocoService,
} from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { AMP_DEFAULT_CURRENCY, AMP_DEFAULT_LOCALE, AMP_DEFAULT_TIMEZONE } from './defaults';
import { AmpPseudoLocaleInterceptor } from './pseudo-locale.interceptor';
import { capturePseudoLocaleFromLocation } from './pseudo-locale';
import { AMP_CURRENCY, AMP_LOCALE, AMP_TIMEZONE } from './tokens';
import { AmpTranslocoLoader } from './transloco.loader';

export function provideAmpI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: LOCALE_ID, useValue: AMP_DEFAULT_LOCALE },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: AMP_DEFAULT_TIMEZONE } },
    { provide: AMP_LOCALE, useExisting: LOCALE_ID },
    { provide: AMP_TIMEZONE, useValue: AMP_DEFAULT_TIMEZONE },
    { provide: AMP_CURRENCY, useValue: AMP_DEFAULT_CURRENCY },
    provideAppInitializer(() => capturePseudoLocaleFromLocation()),
    provideAppInitializer(() => {
      const transloco = inject(TranslocoService);
      return transloco.load('en');
    }),
    ...provideTransloco({
      config: {
        availableLangs: ['en'],
        defaultLang: 'en',
        fallbackLang: 'en',
        prodMode: !isDevMode(),
        reRenderOnLangChange: true,
        missingHandler: {
          useFallbackTranslation: false,
          logMissingKey: isDevMode(),
        },
      },
      loader: AmpTranslocoLoader,
    }),
    provideTranslocoMessageformat(),
    provideTranslocoInterceptor(AmpPseudoLocaleInterceptor),
  ]);
}
